import { MILESTONE_TYPE_LABELS } from "@inthraction/labels";

export type MilestoneType = keyof typeof MILESTONE_TYPE_LABELS;

export const MILESTONE_TYPES = Object.keys(MILESTONE_TYPE_LABELS) as MilestoneType[];
